import { Link } from "react-router-dom";

const NotFoundPage = () => {
  return (
    <div className="container py-5 text-center">
      <h1 className="mb-3">Página não encontrada</h1>
      <p className="mb-4">A rota acessada não existe ou o parceiro não foi encontrado.</p>
      <Link to=".." relative="path" className="btn btn-primary">
        Voltar
      </Link>
    </div>
  );
};

export default NotFoundPage;



